module.exports = __webpack_public_path__ + "img/reports.27f965c2.svg";